/* @flow */

import * as React from 'react';
import { range } from 'lodash/fp';

import SelectedEntityRow from './SelectedEntityRow';
import { getFactoredEntityPositionSalary } from '../../../selectors/salaryExpenditureSelector';

type Props = {
  position: Object,
  positions: Array<Object>,
  remaining: number,
  onSelectSettingsTab: (tab: string) => void,
  onRemove: () => void,
  onSwitchSelectedPosition: () => void
};

const LineUpSection = ({
  position: { id, filled, abbr, selections },
  onSwitchSelectedPosition,
  onSelectSettingsTab,
  onRemove,
  positions,
  remaining
}: Props) => {
  return (
    <React.Fragment>
      {selections.map(
        ({
          idStr,
          name,
          imageURI,
          initials,
          image,
          insiderWarning,
          labels,
          salary,
          positions: entityPositions
        }) => {
          const alterPosition = entityPositions.find(p => p.key !== id);
          return (
            <SelectedEntityRow
              key={idStr}
              idStr={idStr}
              initials={initials}
              name={name}
              image={imageURI || image}
              positionId={id}
              positionAbbr={abbr}
              labels={labels}
              salary={getFactoredEntityPositionSalary(salary, entityPositions, id)}
              warning={insiderWarning}
              alterPosition={
                alterPosition ? positions.find(p => p.id === alterPosition.key) : undefined
              }
              onSelectSettingsTab={onSelectSettingsTab}
              onSwitchSelectedPosition={onSwitchSelectedPosition}
              onRemove={onRemove}
            />
          );
        }
      )}
      {!filled && (
        <React.Fragment>
          {range(0, remaining).map(i => (
            <SelectedEntityRow key={i} positionAbbr={abbr} />
          ))}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default LineUpSection;
